import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  isConnected: boolean
} & HTMLAttributes<HTMLSpanElement>
export const IntegrationCardStatus = ({
  className,
  isConnected,
  ...props
}: Props) => {
  const styles = {
    'bg-green-100 border !border-green-200/40 text-green-800': isConnected,
    'bg-red-100 border !border-red-200/40 text-red-800': !isConnected,
  }
  let title = 'Connected'
  if (!isConnected) {
    title = 'Disconnected'
  }
  return (
    <span
      className={cn(
        'rounded-full bg-gray-100 px-2 py-1 text-xs font-semibold text-gray-800',
        styles,
        className
      )}
      {...props}
    >
      {title}
    </span>
  )
}
